import React from "react";
import "./index.css";
import { twMerge } from "tailwind-merge";
export default function WaveLoading({ containerClass = "" }) {
  return (
    <div className={twMerge("grid place-items-center h-screen", containerClass)}>
      <div className="waveform">
        <div className="waveform__bar"></div>
        <div className="waveform__bar"></div>
        <div className="waveform__bar"></div>
        <div className="waveform__bar"></div>
      </div>
    </div>
  );
}
